<template>
    <v-card>
        <v-data-table-virtual :headers="headers" :items="cuestionario.preguntas" :search="search" :loading="loading"
            @click:row="editPregunta">
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>{{ t('Preguntas') }}</v-toolbar-title>
                    <v-btn color="primary" @click="newPregunta">
                        <v-icon icon="mdi-plus" start></v-icon>
                        <template v-if="display.mdAndUp.value">
                            {{ t('Anadir') }} {{ t('pregunta') }}
                        </template>
                    </v-btn>
                    <v-btn color="primary" @click="$emit('detalles-cuestionario')" prepend-icon="mdi-cog">
                        {{ t('cuestionario') }}
                    </v-btn>
                    <v-btn icon @click="closePreguntas">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-text-field class="mx-4 mt-4" v-model="search" label="Cerca" prepend-inner-icon="mdi-magnify"
                    single-line variant="outlined" hide-details></v-text-field>
            </template>
            <template v-slot:[`item.dificultad`]="{ value }">
                <v-chip :color="getColor(value)">
                    {{ value }}
                </v-chip>
            </template>
            <template v-slot:loading>
                <v-skeleton-loader type="table-row@10"></v-skeleton-loader>
            </template>
        </v-data-table-virtual>
    </v-card>
    <v-dialog v-model="editDialog" persistent :fullscreen="display.smAndDown.value">
        <v-card>
            <v-toolbar flat>
                <v-toolbar-title>{{ t('Editar') }} {{ t('pregunta') }}</v-toolbar-title>
                <v-btn color="primary" @click="detallsPregunta">
                    <v-icon icon="mdi-cog" start></v-icon>
                    <template v-if="display.mdAndUp.value">
                        {{ t('pregunta') }}
                    </template>
                </v-btn>
                <v-btn icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-text-field disabled v-model="editedPregunta.texto" :label="t('Pregunta')"></v-text-field>
                <v-select disabled v-model="editedPregunta.tipo" :items="tiposPreguntas" :label="t('Tipo')"></v-select>
                <v-select disabled v-model="editedPregunta.dificultad" :items="nivelesDificultad"
                    :label="t('Dificultad')"></v-select>
                <!-- Verifica si hay una URL de imagen y muestra el thumbnail -->
                <template v-if="editedPregunta.imagen_thub">
                    <!-- If it's an image -->
                    <v-img v-if="editedPregunta.imagen_type && editedPregunta.imagen_type.startsWith('image/')"
                        :src="editedPregunta.imagen_thub" height="100" />
                    <!-- If it's a video -->
                    <video v-else-if="editedPregunta.imagen_type && editedPregunta.imagen_type.startsWith('video/')"
                        controls style="max-width: 300px;">
                        <source :src="editedPregunta.imagen_thub" :type="editedPregunta.imagen_type" />
                        <!-- Provide fallback text if needed -->
                        {{ t('Tu navegador no soporta el video') }}
                    </video>
                </template>

                <v-data-table :headers="headersOp" :items="editedPregunta.opciones" @click:row="editOpcion"
                    hide-default-footer>
                    <template v-slot:top>
                        <v-toolbar flat>
                            <v-toolbar-title>{{ t('Opciones') }}</v-toolbar-title>
                            <v-btn color="primary" @click="newOpcion">
                                <v-icon>mdi-plus</v-icon>
                                {{ t('Anadir') }} {{ t('opción') }}
                            </v-btn>
                        </v-toolbar>
                    </template>
                    <template v-slot:[`item.es_correcta`]="{ item }">
                        <v-checkbox v-model="item.es_correcta" readonly></v-checkbox>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-dialog>
    <v-dialog v-model="crearPDialog" persistent :fullscreen="display.smAndDown.value">
        <v-card>
            <v-toolbar flat>
                <v-toolbar-title>{{ t('Crear') }} {{ t('pregunta') }}</v-toolbar-title>
                <v-btn v-if="editedPregunta.id" color="error" text @click="eliminar('preguntas', editedPregunta.id)">
                    <v-icon icon="mdi-delete-forever" start></v-icon>
                    <template v-if="display.mdAndUp.value">
                        {{ t('Eliminar') }}
                    </template>
                </v-btn>
                <v-btn color="primary" text @click="save">
                    <v-icon icon="mdi-content-save" start></v-icon>
                    <template v-if="display.mdAndUp.value">
                        {{ t('Guardar') }}
                    </template>
                </v-btn>
                <v-btn icon @click="closePDialog">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-text-field v-model="editedPregunta.texto" :label="t('Pregunta')">
                    <template v-slot:append>
                        <HelpComponent helpType="pregunta_texto"></HelpComponent>
                    </template>
                </v-text-field>
                <v-text-field v-model="editedPregunta.orden" :label="t('Orden')">
                    <template v-slot:append>
                        <HelpComponent helpType="pregunta_orden"></HelpComponent>
                    </template>
                </v-text-field>
                <v-select v-model="editedPregunta.tipo" :items="tiposPreguntas" :label="t('Tipo')">
                    <template v-slot:append>
                        <HelpComponent helpType="pregunta_tipo"></HelpComponent>
                    </template>
                </v-select>
                <v-select v-model="editedPregunta.dificultad" :items="nivelesDificultad" :label="t('Dificultad')">
                    <template v-slot:append>
                        <HelpComponent helpType="pregunta_dificultad"></HelpComponent>
                    </template>
                </v-select>
                <v-file-input v-model="editedPregunta.imagen" :label="t('Imagen') + ' ' + t('o') + ' ' + t('video')"
                    prepend-icon="mdi-camera" :accept="editedPregunta.tipo === 'hotspot' ? 'image/*' : 'image/*,video/*'" @change="handleFileUpload">
                    <template v-slot:append>
                        <HelpComponent helpType="pregunta_imagen"></HelpComponent>
                    </template>
                </v-file-input>
                <!-- Verifica si hay una URL de imagen y muestra el thumbnail -->
                <template v-if="editedPregunta.imagen_thub">
                    <!-- If it's an image -->
                    <v-img v-if="editedPregunta.imagen_type && editedPregunta.imagen_type.startsWith('image/')"
                        :src="editedPregunta.imagen_thub" height="100" />
                    <!-- If it's a video -->
                    <video v-else-if="editedPregunta.imagen_type && editedPregunta.imagen_type.startsWith('video/')"
                        controls style="max-width: 300px;">
                        <source :src="editedPregunta.imagen_thub" :type="editedPregunta.imagen_type" />
                        <!-- Provide fallback text if needed -->
                        {{ t('Tu navegador no soporta el video') }}
                    </video>
                </template>

            </v-card-text>
        </v-card>
    </v-dialog>
    <v-dialog v-model="editOpcionDialog" persistent :fullscreen="display.smAndDown.value">
        <v-card>
            <v-toolbar flat>
                <v-toolbar-title>{{ t('Editar') }} {{ t('opción') }}</v-toolbar-title>
                <v-btn v-if="editedOpcion.id" color="error" text @click="eliminar('opciones', editedOpcion.id)">
                    <v-icon icon="mdi-delete-forever" start></v-icon>
                    <template v-if="display.mdAndUp.value">
                        {{ t('Eliminar') }}
                    </template></v-btn>
                <v-btn color="primary" text @click="saveOp">
                    <v-icon icon="mdi-content-save" start></v-icon>
                    <template v-if="display.mdAndUp.value">
                        {{ t('Guardar') }}
                    </template>
                </v-btn>
                <v-btn icon @click="closeOpciones">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <HelperCarregant v-if="loading" :missatge="t('Actualizando') + ' ' + t('opción')" />
                <template v-if="!loading">
                    <v-text-field v-model="editedOpcion.texto" :label="t('Opción')">
                        <template v-slot:append>
                            <HelpComponent helpType="opcion_texto"></HelpComponent>
                        </template>
                    </v-text-field>
                    <v-checkbox v-model="editedOpcion.es_correcta" :label="t('Es_correcta')">
                        <template v-slot:append>
                            <HelpComponent helpType="opcion_correcta"></HelpComponent>
                        </template>
                    </v-checkbox>
                    <v-text-field v-model="editedOpcion.texto2" :label="t('Relación')">
                        <template v-slot:append>
                            <HelpComponent helpType="opcion_relacion"></HelpComponent>
                        </template>
                    </v-text-field>
                    <v-text-field v-model="editedOpcion.orden" :label="t('Orden')">
                        <template v-slot:append>
                            <HelpComponent helpType="opcion_orden"></HelpComponent>
                        </template>
                    </v-text-field>
                    <v-text-field v-model="editedOpcion.motivo" :label="t('Explicación')">
                        <template v-slot:append>
                            <HelpComponent helpType="opcion_explicacion"></HelpComponent>
                        </template>
                    </v-text-field>
                    <HotspotPolygonEditor
                        v-if="editOpcionDialog && editedPregunta.tipo === 'hotspot'"
                        :key="editedOpcion.id || 'nueva'"
                        v-model="editedOpcion.region"
                        :image="editedPregunta.imagen_thub"
                        class="mt-4"
                    />
                </template>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script setup>
import { ref } from 'vue'
import HelperCarregant from './HelperCarregant.vue'
import HelpComponent from './HelpComponent.vue'
import HotspotPolygonEditor from './HotspotPolygonEditor.vue'
import { axios } from '../axios'
import { useI18n } from 'vue-i18n'
import { useDisplay } from 'vuetify';
import { useUiStore } from '@/stores/ui';
const uiStore = useUiStore();   

// Define props & emits
const props = defineProps({
    cuestionario: {
        type: Object,
        default: () => ({})
    },
    loading: {
        type: Boolean,
        default: false,
    }
})
const emits = defineEmits(['actualizar-preguntas', 'cerrar-preguntas'])

const display = useDisplay();
const { t } = useI18n()

// Reactive data
const headers = ref([
    { title: t('ID'), key: 'id' },
    { title: t('Pregunta'), key: 'texto' },
    { title: t('Tipo'), key: 'tipo' },
    { title: t('Opciones'), key: 'opciones.length' },
    { title: t('Dificultad'), key: 'dificultad' },
    { title: t('Orden'), key: 'orden' },
])

const headersOp = ref([
    { title: t('ID'), key: 'id' },
    { title: t('Texto'), key: 'texto' },
    { title: t('Relación'), key: 'texto2' },
    { title: t('Orden'), key: 'orden' },
    { title: t('Es_correcta'), key: 'es_correcta' },
    { title: t('Explicación'), key: 'motivo' },
])

const editDialog = ref(false)
const crearPDialog = ref(false)
const editOpcionDialog = ref(false)

const editedPregunta = ref({})
const editedOpcion = ref({})
const search = ref('')
const tiposPreguntas = ref([
    'multiple_choice',
    'single_choice',
    'relacionar',
    'relacionar_cols',
    'ordenar',
    'gradacion',
    'texto',
    'contenido',
    'hotspot'
])
const nivelesDificultad = ref(['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'])
const loading2 = ref(false)
const snackbarText = ref('')

// Methods
function getColor(dificultad) {
    if (dificultad > 7) return 'red'
    else if (dificultad > 4) return 'orange'
    return 'green'
}

function newPregunta() {
    editedPregunta.value = {
        id: null,
        cuestionario: props.cuestionario.id,
        texto: '',
        imagen: null,
        imagen_type: null,
        imagen_thub: null,
        tipo: 'multiple_choice',
        opciones: [],
        dificultad: 5,
        orden: null,
    }
    crearPDialog.value = true
}

function editPregunta(e, { item }) {
    // Clone item to avoid mutating original
    editedPregunta.value = {
        ...item,
        cuestionario: props.cuestionario.id,
        imagen: null,
        imagen_thub: item.imagen,
        imagen_type: item.imagen ? guessMimeType(item.imagen) : null,
    }
    editDialog.value = true
}

function guessMimeType(url) {
    const extension = url
        .split('?')[0]          // ignore query params, if any
        .split('.')
        .pop()
        .toLowerCase()

    if (['mp4', 'mov', 'avi', 'mkv'].includes(extension)) {
        return 'video/mp4'
    }
    if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'].includes(extension)) {
        return `image/${extension}`
    }
    // fallback if unknown
    return null
}

function detallsPregunta() {
    crearPDialog.value = true
}

function newOpcion() {
    editedOpcion.value = {
        id: null,
        pregunta: editedPregunta.value.id,
        texto: '',
        texto2: '',
        es_correcta: false,
        orden: 0,
        region: null,
        motivo: ''
    }
    editOpcionDialog.value = true
}

function editOpcion(e, { item }) {
    editedOpcion.value = {
        ...item,
        pregunta: editedPregunta.value.id
    }
    editOpcionDialog.value = true
}

function handleFileUpload(event) {
    const files = event.target.files
    if (files && files.length > 0) {
        // Use the first file
        const file = files[0]
        editedPregunta.value.imagen = file        // actual File object
        editedPregunta.value.imagen_type = file.type // "image/png", "video/mp4", etc.

        // Use FileReader to create a base64 string for preview (thumbnail)
        const reader = new FileReader()
        reader.onload = (e) => {
            editedPregunta.value.imagen_thub = e.target.result
        }
        reader.readAsDataURL(file)
    } else {
        // Reset if no file
        editedPregunta.value.imagen = null
        editedPregunta.value.imagen_type = null
        editedPregunta.value.imagen_thub = null
    }
}


async function save() {
    loading2.value = true
    const formData = new FormData()
    for (const key in editedPregunta.value) {
        const value = editedPregunta.value[key]
        if (value !== null && value !== undefined) {
            if (key === 'imagen' && value instanceof File) {
                formData.append(key, value)
            } else {
                formData.append(key, value)
            }
        }
    }

    try {
        if (editedPregunta.value.id) {
            await axios.put(`preguntas/${editedPregunta.value.id}/`, formData)
            uiStore.triggerSnackbar({ message: t('actualizado_con_éxito'), color: 'success' });
        } else {
            await axios.post('preguntas/', formData)
            uiStore.triggerSnackbar({ message: t('creado_con_éxito'), color: 'success' });
        }
        emits('actualizar-preguntas')
        editDialog.value = false
        crearPDialog.value = false
    } catch (error) {
        if (error.response && error.response.data && typeof error.response.data === 'object') {
            const errors = error.response.data
            let errorMessage = ''
            Object.keys(errors).forEach(key => {
                errorMessage += `${key}: ${errors[key].join(' ')}\n`
            })
            snackbarText.value = errorMessage
        } else {
            snackbarText.value = error
        }
        uiStore.triggerSnackbar({ message: snackbarText.value, color: 'error' });
    } finally {
        loading2.value = false
    }
}

async function saveOp() {
    if (editedPregunta.value.tipo === 'hotspot' && !editedOpcion.value.region) {
        uiStore.triggerSnackbar({
            message: t('Hotspot_editor_minimo_tres_puntos'),
            color: 'error'
        });
        return;
    }
    loading2.value = true
    try {
        // find the question in cuestionario
        const index_p = props.cuestionario.preguntas.findIndex(
            (m) => m.id === editedOpcion.value.pregunta
        )
        // find the option in the question
        const index_o =
            props.cuestionario.preguntas[index_p].opciones.findIndex(
                (m) => m.id === editedOpcion.value.id
            )

        if (editedOpcion.value.id) {
            const response = await axios.put(`opciones/${editedOpcion.value.id}/`, editedOpcion.value)
            editedPregunta.value.opciones.splice(index_o, 1, response.data)
            uiStore.triggerSnackbar({ message: t('actualizado_con_éxito'), color: 'success' });
        } else {
            const response = await axios.post('opciones/', editedOpcion.value)
            editedPregunta.value.opciones.push(response.data)
            uiStore.triggerSnackbar({ message: t('creado_con_éxito'), color: 'success' });
        }
        emits('actualizar-preguntas')
        editOpcionDialog.value = false
    } catch (error) {
        if (error.response && error.response.data && typeof error.response.data === 'object') {
            const errors = error.response.data
            let errorMessage = ''
            Object.keys(errors).forEach(key => {
                errorMessage += `${key}: ${errors[key].join(' ')}\n`
            })
            snackbarText.value = errorMessage
        } else {
            snackbarText.value = error
        }
        uiStore.triggerSnackbar({ message: snackbarText.value, color: 'error' });
    } finally {
        loading2.value = false
    }
}

function close() {
    editDialog.value = false
}
function closePDialog() {
    crearPDialog.value = false
}
function closePreguntas() {
    emits('cerrar-preguntas')
}
function closeOpciones() {
    editOpcionDialog.value = false
}

function eliminar(tipo, id) {
    if (
        confirm(
            '¿Estás seguro de que quieres eliminar esta pregunta u opción? Esta acción no se puede deshacer.'
        )
    ) {
        eliminarfinal(tipo, id);
    }
}

async function eliminarfinal(tipo, id) {
    try {
        await axios.delete(`${tipo}/${id}`);
        snackbarText.value = t('eliminado_con_éxito');
        uiStore.triggerSnackbar({ message: t('eliminado_con_éxito'), color: 'success' });
        emits('actualizar-preguntas')
    } catch (error) {
        uiStore.triggerSnackbar({ message: error, color: 'error' });
    }
    editDialog.value = false
    crearPDialog.value = false
    editOpcionDialog.value = false
}

</script>